import { createSelector } from 'reselect';
import { getMediaAssetsMap } from '../../../../redux/files/files.selectors';
import { StoreState } from '../../../../redux/reducers/store.types';
import { MediaAsset } from '../../../../types/media-assets';
import { MaybeUndef, StringMap } from '../../../../types/system';
import { OwnProps } from './thumb-by-file-id.container';

const getFileIdForThumbComponent = (state: StoreState, { fileId }: OwnProps) =>
  fileId;

export const getMediaAssetById = createSelector(
  getFileIdForThumbComponent,
  getMediaAssetsMap,
  (fileId: string, filesMap: StringMap<MediaAsset>): MaybeUndef<MediaAsset> => {
    return filesMap[fileId];
  },
);
